
export default [
    {
        path: '/',
        meta: {
            title: '净慈寺',
            cId: 91
        },
        component: () => import('@/views/Index')
    },
    {
        path: '/login',
        meta: {
            title: '用户登录'
        },
        component: () => import('@/views/Login')
    },
    {
        path: '/logout',
        component: () => import('@/views/Logout')
    },
    {
        path: '/pay-test',
        meta: {
            title: '支付测试'
        },
        component: () => import('@/views/PayTest')
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/404'
    }

]